module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?64d4cf64afd77a4ad2713f648eb920e6";